import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import '../ErrorPage/ErrorPage.css';

const UnauthorizedComponent = () => {
  const navigate = useNavigate();
  const { isLoggedIn, role } = useSelector((state) => state.auth);

  const handleNavigateHome = () => {
    if (!isLoggedIn) {
      // If not logged in, redirect to appropriate login page
      navigate('/');
    } else if (role === 'Superadmin') {
      navigate('/admin-dashboard');
    } else {
      navigate('/dashboard');
    }
  };

  return (
    <div className="error-page">
      <h1>Unauthorized</h1>
      <p>You donot have permission to access this page.</p>
      <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
        <button onClick={handleNavigateHome}>{isLoggedIn ? 'Go to Dashboard' : 'Go to Home'}</button>
      </div>
    </div>
  );
};

export default UnauthorizedComponent;
